import UIFetchService from '../Service/UIFetchService';
import { toThousands, userTagsBaseFields } from '../Service/Utils';

import { Col, Row, Table, Tabs, Skeleton, Divider } from 'antd';
import { } from '@ant-design/icons';
import React from 'react';

class UserTagsDetail extends React.Component {
    constructor() {
        super();
        this.state = {
            activeTab: 'BIZ_META',
            metadata: {},
            tag: {
                extraData: {}
            }
        };
    }

    render() {
        return <>
            <Row>
                <Col flex='50%' style={{ padding: '10px 60px 0 60px' }}>
                    <Row justify='center'>
                        <Col>
                            <span>数据分布</span>
                        </Col>
                    </Row>
                    <Row justify='center'>
                        <Col flex="200px">
                            <Divider style={{ margin: '5px' }} />
                        </Col>
                    </Row>

                    {this.state.statistics === undefined
                        ? <Skeleton loading={true} active avatar></Skeleton>
                        : this.renderCoverage()}
                </Col>
                <Col flex='50%'>
                    <Tabs
                        activeKey={this.state.activeTab}
                        onChange={activeTab => this.setState({ activeTab })}
                        centered
                        style={{ width: '100%' }}
                    >
                        <Tabs.TabPane tab="业务元信息" key="BIZ_META">
                            {this.renderBizFields()}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="技术元信息" key="TECH_META">
                            {this.renderExtFields('TECH_META')}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="质量元信息" key="QUALITY_META">
                            {this.renderExtFields('QUALITY_META')}
                        </Tabs.TabPane>
                    </Tabs>
                </Col>
            </Row>
        </>;
    }

    renderBizFields() {
        const metadata = this.state.metadata.BIZ_META === undefined ? [] : this.state.metadata.BIZ_META;
        const data = this.state.tag.extraData.BIZ_META === undefined ? {} : this.state.tag.extraData.BIZ_META;
        return <div
            style={{
                margin: '10px 60px 0 60px',
                border: '1px solid #bfbfbf'
            }}
        >
            {userTagsBaseFields.map((field, index) => <Row
                style={{
                    padding: '10px 0 10px 0',
                    borderBottom: '1px solid #bfbfbf'
                }}
            >
                <Col flex="25%" style={{ alignSelf: 'center', textAlign: 'right' }}>{field.title}:</Col>
                <Col flex="10px"></Col>
                <Col flex="60%" style={{ textAlign: 'left', wordBreak: 'break-all' }}>{this.state.tag[field.index]}</Col>
            </Row>)}
            {metadata.map((field, index) => <Row
                style={{
                    padding: '10px 0 10px 0',
                    borderBottom: '1px solid #bfbfbf'
                }}
            >
                <Col flex="25%" style={{ alignSelf: 'center', textAlign: 'right' }}>{field.name}:</Col>
                <Col flex="10px"></Col>
                <Col flex="60%" style={{ textAlign: 'left', wordBreak: 'break-all' }}>{data[field.name]}</Col>
            </Row>)}
        </div>;
    }

    renderExtFields(kind) {
        const metadata = this.state.metadata[kind] === undefined ? [] : this.state.metadata[kind];
        const data = this.state.tag.extraData[kind] === undefined ? {} : this.state.tag.extraData[kind];

        return <div
            style={{
                margin: '10px 60px 0 60px',
                border: '1px solid #bfbfbf'
            }}
        >
            {metadata.map((field, index) => <Row
                style={{
                    padding: '10px 0 10px 0',
                    borderBottom: '1px solid #bfbfbf'
                }}
            >
                <Col flex="25%" style={{ alignSelf: 'center', textAlign: 'right' }}>{field.name}:</Col>
                <Col flex="10px"></Col>
                <Col flex="60%" style={{ textAlign: 'left', wordBreak: 'break-all' }}>{data[field.name]}</Col>
            </Row>)}
        </div>;
    }

    renderCoverage() {
        const { tagTotal, active30d, active30dTotal, groupTotal } = this.state.statistics;
        return <>
            <Row>
                <Col>
                    <span style={{ fontSize: 15, fontWeight: 600 }}>整体覆盖率：</span>
                    <span style={{ fontSize: 15, color: 'red' }}>{groupTotal === 0 ? 'N/A' : ((tagTotal / groupTotal) * 100.0).toFixed(2)}%</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span style={{ color: 'gray' }}>说明：集团整体用户数{toThousands(groupTotal)}，有该标签的用户数{toThousands(tagTotal)}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span style={{ fontSize: 15, fontWeight: 600 }}>近30天活跃覆盖率：</span>
                    <span style={{ fontSize: 15, color: 'red' }}>{active30dTotal === 0 ? 'N/A' : ((active30d / active30dTotal) * 100.0).toFixed(2)}%</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span style={{ color: 'gray' }}>说明：近30天活跃用户数{toThousands(active30dTotal)}，有该标签的用户数{toThousands(active30d)}</span>
                </Col>
            </Row>
            <Row style={{ margin: '20px 0 0 0' }}>
                <Col flex="100%">
                    <Table
                        dataSource={this.state.statistics.items}
                        size='small'
                        pagination={false}
                    >
                        <Table.Column
                            title="枚举"
                            dataIndex="key"
                            key="key"
                            render={(_, record) =>
                                <sapn>
                                    {record.key === null ? '未知' : (record.key === '<others>' ? '其他' : record.key)}
                                </sapn>
                            } />
                        <Table.Column
                            title="人数"
                            dataIndex="value"
                            key="value"
                            render={(_, record) =>
                                <span>{toThousands(record.value)}</span>
                            } />
                        <Table.Column
                            title="占比"
                            dataIndex="rate"
                            key="rate"
                            render={(_, record) =>
                                <>
                                    {(record.key === null)
                                        ? <sapn>--</sapn>
                                        : <span>{((record.value / this.state.statistics.tagTotal) * 100).toFixed(2)}</span>}
                                    <sapn>%</sapn>
                                </>
                            } />
                        <Table.Column
                            title="整体覆盖率"
                            dataIndex="coverage"
                            key="coverage"
                            render={(_, record) =>
                                <>
                                    <span>{((record.value / this.state.statistics.groupTotal) * 100).toFixed(2)}</span>
                                    <sapn>%</sapn>
                                </>
                            } />
                        <Table.Column
                            title="近30天活跃覆盖率"
                            dataIndex="coverage30d"
                            key="coverage30d"
                            render={(_, record) =>
                                <>
                                    <span>{((record.value30d / active30dTotal) * 100).toFixed(2)}</span>
                                    <sapn>%</sapn>
                                </>
                            } />
                    </Table>
                </Col>
            </Row>
            <Row style={{ margin: '10px 0 0 0' }}>
                <Col>
                    <span style={{ color: 'gray' }}>数据更新时间：{this.state.statistics.date}</span>
                </Col>
            </Row>
        </>;
    }

    async componentDidMount() {
        const metaRecords = await UIFetchService.get('/api/v1/user_tags/metadata');
        console.log(metaRecords);
        if (!metaRecords) {
            return;
        }
        const metadata = {};
        metaRecords.map(d => {
            d.key = (this.uniqueKey++).toString();
            return d;
        }).forEach(d => {
            let items = metadata[d.kind];
            if (items === undefined) {
                items = [];
                metadata[d.kind] = items;
            }
            items.push(d);
        });

        this.setState({ metadata });
        const tag = await UIFetchService.get(`/api/v1/user_tags/tags/${this.props.tagId}`);
        this.setState({ tag });

        UIFetchService.get(`/api/v1/user_tags/tags/${this.props.tagId}/statistics`)
            .then(statistics => this.setState({ statistics }));
    }
}

class VxTabs extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }


}

export default UserTagsDetail;